import classes from "./Careers.module.css";

const Careers = () => {
  return <div className={classes.container}></div>;
};

export default Careers;
